import React from "react"

const DEFAULT_QUESTIONS = [
  "Which companies have the highest Scope 1 emissions?",
  "Who leads in board diversity across sectors?",
  "Compare external assurance adoption by country",
  "What ESRS standards does BMW disclose against?",
  "Show me companies with net-zero transition plans",
]

const FOLLOW_UP_MAP = {
  structured: [
    "How does this compare to the sector average?",
    "Show me the same metric for competitors",
    "What was this number last year?",
  ],
  analytical: [
    "Which company improved the most year-over-year?",
    "Break this down by sector",
    "What drives these differences?",
  ],
  narrative: [
    "How does their approach compare to peers?",
    "What are the key risks they identified?",
    "Summarize their transition plan",
  ],
  novel: [
    "Can you go deeper on this trend?",
    "What are the implications for investors?",
    "Which companies are best positioned?",
  ],
}

const SuggestedQuestions = ({ onSelect, category, isFollowUp = false }) => {
  const questions = isFollowUp && category
    ? FOLLOW_UP_MAP[category] || FOLLOW_UP_MAP.novel
    : DEFAULT_QUESTIONS

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: isFollowUp ? "12px" : "0" }}>
      {!isFollowUp && (
        <p style={{ width: "100%", fontSize: "12px", color: "#707070", margin: "0 0 4px 0" }}>
          Try asking:
        </p>
      )}
      {questions.map((q, i) => (
        <button
          key={i}
          onClick={() => onSelect(q)}
          style={{
            padding: "6px 14px",
            borderRadius: "16px",
            border: "1px solid #407775",
            backgroundColor: "transparent",
            color: "#407775",
            fontSize: "12px",
            cursor: "pointer",
            transition: "all 0.15s",
            lineHeight: "1.3",
            textAlign: "left",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#407775"
            e.currentTarget.style.color = "#fff"
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent"
            e.currentTarget.style.color = "#407775"
          }}
        >
          {q}
        </button>
      ))}
    </div>
  )
}

export default SuggestedQuestions
